import { email } from 'vee-validate/dist/rules';

export default function addVeeValidateRules (VeeValidateExtend) {
  VeeValidateExtend('required', {
    validate: value => value !== null && String(value).trim() !== '',
    computesRequired: true,
    message: 'This field is required'
  });

  VeeValidateExtend('email', {
    ...email,
    message: 'The valid e-mail is required'
  });

  VeeValidateExtend('valid-url', {
    validate: value => {
      if (value === '') {
        return true;
      }

      let urlPattern = new RegExp('^(https?:\\/\\/)?((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*(\\?[;&a-z\\d%_.~+=-]*)?(\\#[-a-z\\d_]*)?$', 'i');
      return !!urlPattern.test(value);
    },
    computesRequired: true,
    message: 'The valid URL is required'
  })

  VeeValidateExtend('only-big-letters', {
    validate: value => value === value.replace(/[^A-Z]/gm, ''),
    computesRequired: true,
    message: 'This field can contains only big letters'
  });

  VeeValidateExtend('only-numbers', {
    validate: value => value === value.replace(/[^0-9.]/gm, '') && !Number.isNaN(parseFloat(value.replace(/[^0-9.]/gm, ''))),
    computesRequired: true,
    message: 'This value must be a number'
  });

  VeeValidateExtend('slot-time', {
    validate: value => !value || (value && value.match(/^[0-9]{4,4}$/gm) && parseInt(value, 10) >= 0 && parseInt(value, 10) <= 2359),
    computesRequired: true,
    message: 'This value must be a value between 0000 and 2359'
  });

  VeeValidateExtend('only-letters-and-dashes', {
    validate: value => value === value.replace(/[^a-zA-Z-]/gm, ''),
    computesRequired: true,
    message: 'This field can contains only letters and dashes'
  });

  VeeValidateExtend('min', {
    params: ['min'],
    validate: (value, { min }) => value.length >= min,
    message: (field, params) => {
      if (params.min === 1) {
        return 'This field must contains at least one character';
      }

      return 'This field must contains at least ' + params.min + ' characters';
    }
  });

  VeeValidateExtend('max', {
    params: ['max'],
    validate: (value, { max }) => value.length <= max,
    message: (field, params) => {
      if (params.max === 1) {
        return 'This field must contains at max. one character';
      }

      return 'This field msut contains at max. ' + params.max + ' characters';
    }
  });

  VeeValidateExtend('min_value', {
    params: ['minValue'],
    validate: (value, { minValue }) => parseFloat(value) >= parseFloat(minValue),
    message: (field, params) => 'This value cannot be smaller than ' + params.minValue
  });

  VeeValidateExtend('max_value', {
    params: ['maxValue'],
    validate: (value, { maxValue }) => parseFloat(value) <= parseFloat(maxValue),
    message: (field, params) => 'This value cannot be bigger than ' + params.maxValue
  });

  VeeValidateExtend('password', {
    params: [{
      name: 'original',
      isTarget: true
    }],
    validate: (value, { original }) => value === original,
    message: 'The provided passwords are not the same'
  });

  VeeValidateExtend('requiredDateRange', {
    validate: value => value.startDate !== null,
    computesRequired: true,
    message: 'At least start date is required'
  });

  VeeValidateExtend('strong_password', {
    validate: value => value === '' || (value.length >= 12 && value.match(/[a-z]/gm) && value.match(/[A-Z]/gm) && value.match(/[0-9]/gmi) && value.match(/[\/\.\,`~§£!@#$%^&*\\\(\)\_\+\|\[\]\{\}]/gm)),
    computesRequired: true,
    message: 'The password must be at least 12 characters length and contains: at least one small letter, at least one big letter, at least one digit and at least one special character'
  });
};
